import { useInfiniteQuery } from '@tanstack/react-query';
import {
  pointsTransactionsService,
  FetchPointsTransactionsRequest,
  FetchPointsTransactionsResponse,
  useToast,
} from '@aslanpay/portal-common-lib';

type UseFetchPointsProps = Omit<FetchPointsTransactionsRequest, 'page'> & {
  size: number;
};

const useInfiniteFetchPointsTransactions = (
  {
    ids,
    individualIds,
    potIds,
    walletIds,
    companyIds,
    moneyTransactionIds,
    directions,
    categories,
    reasons,
    startDate,
    endDate,
    sortBy,
    sort,
    size,
  }: UseFetchPointsProps,
  enabled = true
) => {
  const toast = useToast();

  return useInfiniteQuery<FetchPointsTransactionsResponse, Error>({
    queryKey: [
      'fetchPayCalendars',
      ids,
      individualIds,
      potIds,
      walletIds,
      companyIds,
      moneyTransactionIds,
      directions,
      categories,
      reasons,
      startDate,
      endDate,
      sortBy,
      sort,
      size,
    ],
    queryFn: ({ pageParam = 0 }) =>
      pointsTransactionsService.fetchPointsTransactions({
        ids,
        individualIds,
        potIds,
        walletIds,
        companyIds,
        moneyTransactionIds,
        directions,
        categories,
        reasons,
        startDate,
        endDate,
        sortBy,
        sort,
        size,
        page: pageParam,
      }),
    getNextPageParam: (lastPage) => {
      const hasMore = (lastPage.pageNumber + 1) * lastPage.pageSize < lastPage.total;
      return hasMore ? lastPage.pageNumber + 1 : undefined;
    },
    enabled,
    onError: () => {
      toast({
        position: 'top-right',
        status: 'error',
        title: 'Something went wrong',
        description: 'Sorry, we failed to fetch the pay calendars. Please try again.',
      });
    },
  });
};

export default useInfiniteFetchPointsTransactions;
